import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
} from "recharts";

const COLORS = {
  withUser: "#009728",
  withoutUser: "#FAAD14",
};

export default function MonthChart({ data, onMonthClick }) {
  const handleBarClick = (_entry, index) => {
    if (data[index] && data[index].month) {
      onMonthClick(data[index].month);
    }
  };

  return (
    <ResponsiveContainer width="100%" height={420}>
      <BarChart
        data={data}
        margin={{ top: 30, right: 30, left: 10, bottom: 120 }}
      >
        {/* Líneas de fondo */}
        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />

        {/* EJE X */}
        <XAxis
          dataKey="month"
          angle={-45}
          textAnchor="end"
          height={90}
          tick={{ fontSize: 12 }}
          interval={0}
        >
          <Label
            value="Meses"
            offset={-60}
            position="insideBottom"
            style={{ fill: "#444", fontSize: 14, textAnchor: "middle", }}
          />
        </XAxis>

        {/* EJE Y */}
        <YAxis>
          <Label
            value="Cantidad de Archivos"
            angle={-90}
            position="insideLeft"
            style={{ textAnchor: "middle", fill: "#444", fontSize: 14 }}
          />
        </YAxis>

        {/* TOOLTIP */}
        <Tooltip
          formatter={(value, name) =>
            name === "withUser"
              ? [`${value}`, "Con Participante"]
              : [`${value}`, "Sin Participante"]
          }
          labelFormatter={(label) => `Mes: ${label}`}
          contentStyle={{
            backgroundColor: "#ffffff",
            border: "1px solid #dcdcdc",
            borderRadius: 8,
            padding: 8,
          }}
        />

        {/* LEYENDA SEPARADA */}
        <Legend
          verticalAlign="bottom"
          align="center"
          wrapperStyle={{
            marginTop: 10,     // antes 40
            paddingTop: 0,
            marginBottom: -80,  // nuevo → baja más la leyenda
          }}
        />

        {/* BARRAS */}
        <Bar
          dataKey="withUser"
          name="Con Participante"
          fill={COLORS.withUser}
          stackId="a"
          cursor="pointer"
          onClick={handleBarClick}

        />

        <Bar
          dataKey="withoutUser"
          name="Sin Participante"
          fill={COLORS.withoutUser}
          stackId="a"
          cursor="pointer"
          onClick={handleBarClick}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
